import React from 'react';

const Password = props => (
    <span className="form-input-field">
        <input type="password" className="form-control" {...props.input}/>
    </span>
);

export default Password;
